import React from 'react';

import { useTranslation } from 'modules/common/helpers';

import { Button, Modal } from 'modules/common/components';

import successfulPaymentImg from 'images/img_successful_payment.png';

interface PaymentSuccessfulModalProps {
  onClose: () => void;
}

const PaymentSuccessfulModal = ({ onClose }: PaymentSuccessfulModalProps) => {
  const { t } = useTranslation(['common', 'subscription']);

  return (
    <Modal show onHide={onClose} dataTestid="PaymentSuccessfulModal">
      <img
        src={successfulPaymentImg}
        alt="Successful Payment"
        className="t-text-alpha-600 t-mb-6 t-block t-mx-auto t-max-w-64"
      />
      <h1 className="typo-alpha t-text-center">
        {t('subscription:payment_successful_modal_title')}
      </h1>
      <p className="typo-epsilon t-text-center t-mt-4">
        {t('subscription:payment_successful_modal_description')}
      </p>
      <Button className="t-block t-mx-auto t-mt-6" onClick={onClose}>
        {t('common:close')}
      </Button>
    </Modal>
  );
};

export default PaymentSuccessfulModal;
